var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Provider } from "./provider";
import { Menu } from "./menu";
import { Header } from "./header";
import { Box, useMediaQuery, useTheme } from "@material-ui/core";
import { useStyles } from "./styles";
export var Layout = function (props) {
    var theme = useTheme();
    var smUp = useMediaQuery(theme.breakpoints.up("sm"));
    var classes = useStyles();
    return (_jsx(Provider, __assign({}, props, { children: function (_a) {
            var floatMenu = _a.floatMenu, floatMenuToggle = _a.floatMenuToggle, open = _a.menu.open;
            return (_jsxs(Box, __assign({ className: classes.root }, { children: [_jsx(Menu, __assign({}, props)), _jsxs(Box, __assign({ className: classes.body, style: { paddingLeft: smUp ? (open ? 240 : 42) : 0 } }, { children: [_jsx(Header, __assign({}, props)), props.floatMenu({
                                open: floatMenu.open,
                                onClose: function () { return floatMenuToggle(false); },
                            }), props.children] }))] })));
        } })));
};
